// Supabase istemcisi (~200 KB) ana pakete girmesin diye ilk ihtiyaç anında yüklenir.
// Sayfanın ilk çizimi beklemez; veri sorguları birkaç yüz ms sonra başlar.
// Lazy yüklenen sayfalar supabaseClient'i doğrudan import edebilir.
export const loadSupabase = () => import('../supabaseClient').then(m => m.supabase);
